import { PortableText } from '@portabletext/react';
import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import BannerContent from '@otovo/shared/components/NotificationBanner/BannerContent';
import BannerCTA from '@otovo/shared/components/NotificationBanner/BannerCTA';
import NotificationBanner from '@otovo/shared/components/NotificationBanner/NotificationBanner';
import { logUIEvent } from '@otovo/shared/lib/analytics/analytics';
import { Sanity$Banner } from '@otovo/shared/types/sanityTypes';

type Props = {
  banner: Sanity$Banner;
  onDismiss?: () => void;
};

const componentName = 'SanityBanner';

const SanityBanner = ({ banner, onDismiss = () => {} }: Props) => {
  const { pathname } = useRouter();
  const [isDismissed, setIsDismissed] = useState(false);
  const context = pathname.startsWith('/a/')
    ? 'LandingPage (/a/:id)'
    : 'HomePage (/)';

  const handleDismiss = () => {
    logUIEvent(
      {
        action: `User dismisses the ${componentName}`,
        context,
      },
      { once: true },
    );
    onDismiss();
    setIsDismissed(true);
  };
  const handleClick = () => {
    logUIEvent(
      {
        action: `User clicks CTA on ${componentName}`,
        context,
      },
      { once: true },
    );
  };

  useEffect(() => {
    logUIEvent(
      {
        action: `${componentName} is shown to customer`,
        context,
      },
      { once: true },
    );
  }, [context]);

  const { content, cta } = banner;
  return (
    <NotificationBanner
      type="cta"
      isDismissed={isDismissed}
      onDismiss={handleDismiss}
    >
      <BannerContent>
        <PortableText
          value={content}
          components={{
            block: ({ children }) => <span>{children}</span>,
          }}
        />
        {cta.slug && cta.title && (
          <BannerCTA onClick={handleClick} href={`/a/${cta.slug}`}>
            {cta.title}
          </BannerCTA>
        )}
      </BannerContent>
    </NotificationBanner>
  );
};

SanityBanner.displayName = componentName;

export default SanityBanner;
